import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

type BusinessMembership = {
  business: { id: string; name: string }
  membership: { role: string }
  main_branch: { name: string } | null
}

function WorkspaceSelectionPage() {
  const navigate = useNavigate()
  const [businesses, setBusinesses] = useState<BusinessMembership[]>([])
  const [error, setError] = useState('')

  useEffect(() => {
    async function loadBusinesses() {
      const token = localStorage.getItem('aad_access_token')
      if (!token) {
        navigate('/login', { replace: true })
        return
      }
      try {
        const response = await fetch('/api/businesses/my-businesses', {
          headers: { Authorization: `Bearer ${token}` },
        })
        if (!response.ok) throw new Error()
        const data: { businesses: BusinessMembership[] } = await response.json()
        if (data.businesses.length === 0) navigate('/onboarding', { replace: true })
        else if (data.businesses.length === 1) selectWorkspace(data.businesses[0].business.id)
        else setBusinesses(data.businesses)
      } catch {
        setError('Unable to load your business workspaces.')
      }
    }
    loadBusinesses()
  }, [navigate])

  function selectWorkspace(businessId: string) {
    localStorage.setItem('aad_selected_business_id', businessId)
    navigate('/dashboard', { replace: true })
  }

  return <main><section><h1>Select a business workspace</h1>
    {error && <p role="alert">{error}</p>}
    {businesses.map(({ business, membership, main_branch }) => (
      <button type="button" key={business.id} onClick={() => selectWorkspace(business.id)}>
        {business.name} · {membership.role}{main_branch ? ` · ${main_branch.name}` : ''}
      </button>
    ))}
    <button type="button" onClick={() => navigate('/businesses/new')}>
      Create another business
    </button>
  </section></main>
}

export default WorkspaceSelectionPage
